module.exports = __webpack_public_path__ + "img/sleep.72b5a9b5.svg";